import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
export var isValidForPlatform = function(layoutElement, isMobile) {
    var platform = layoutElement.platform;
    // Adding safety nets in case not all element platforms are specified
    // We can remove PLATFORM_UNKNOWN and undefined once we are sure it's safe to do so.
    if (platform === ILayoutElement.Platform.WEB || platform === ILayoutElement.Platform.PLATFORM_UNKNOWN || platform === undefined) {
        return true;
    }
    if (platform === ILayoutElement.Platform.WEB_MOBILE && isMobile) {
        return true;
    }
    if (platform === ILayoutElement.Platform.WEB_DESKTOP && !isMobile) {
        return true;
    }
    return false;
};
export var isValidForPage = function(layoutElement, currentPage) {
    var page_variant = layoutElement.page_variant, placement = layoutElement.placement;
    if (page_variant === ILayoutElement.PageVariant.ALL) {
        return true;
    }
    // Adding safety nets in case not all element page variants are specified
    // We can remove PAGE_VARIANT_UNKNOWN and undefined once we are sure it's safe to do so.
    if ((page_variant === undefined || page_variant === ILayoutElement.PageVariant.PAGE_VARIANT_UNKNOWN || page_variant === ILayoutElement.PageVariant.FIRST_PAGE) && currentPage === 1) {
        return true;
    }
    if (page_variant === ILayoutElement.PageVariant.ODD && currentPage % 2 === 1) {
        return true;
    }
    if (page_variant === ILayoutElement.PageVariant.EVEN && currentPage % 2 === 0) {
        return true;
    }
    if (currentPage > 1 && placement !== ILayoutElement.Placement.BELOW_TITLE && placement !== ILayoutElement.Placement.ABOVE_TITLE && placement !== ILayoutElement.Placement.TOP) {
        return true;
    }
    return false;
};
